import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Optometry = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.308 12.245c-.3.5-.998.6-1.497.2l-5.488-3.993c-2.994-2.097-7.185-1.398-9.38 1.597-.3.499-.998.599-1.497.2-.5-.3-.599-.999-.2-1.498A8.8 8.8 0 0 1 12.52 6.754l5.489 3.994c.498.399.598 1.098.299 1.497ZM43.355 25.722c-1.298-3.893-4.99-6.589-9.28-6.589-1.298 0-2.495.3-3.593.7l-2.595-1.798c-.498-.3-1.097-.2-1.496.2-.3.499-.2 1.098.2 1.497l1.696 1.198c-2.296 1.598-3.792 4.093-4.092 7.088h-4.49c-.1-.799-.3-1.497-.5-2.196-.698-1.997-1.995-3.694-3.591-4.792L32.677 8.651c2.994-2.196 7.185-1.497 9.38 1.498.3.499.998.599 1.497.2.5-.3.599-.999.2-1.498A8.8 8.8 0 0 0 31.48 6.854L13.618 19.832c-1.098-.499-2.295-.699-3.593-.699-5.588 0-9.978 4.393-9.978 9.884 0 .399 0 .798.1 1.297.598 4.892 4.79 8.586 9.779 8.586 5.089 0 9.28-3.894 9.779-8.885h4.49c.5 4.991 4.69 8.785 9.78 8.785 5.089 0 9.18-3.794 9.779-8.685 0-.4.1-.799.1-1.198.1-.999-.1-2.097-.5-3.195Zm-25.646 3.294c0 4.293-3.492 7.787-7.783 7.787-3.992 0-7.185-2.995-7.684-6.788 0-.3-.1-.6-.1-.998 0-4.293 3.493-7.787 7.784-7.787 1.197 0 2.295.3 3.293.798 1.896.899 3.393 2.496 3.991 4.493.3.798.5 1.597.5 2.495Zm16.365 7.887c-4.29 0-7.883-3.494-7.883-7.886 0-4.293 3.493-7.887 7.883-7.887a7.838 7.838 0 0 1 7.884 7.887c0 4.292-3.493 7.886-7.884 7.886Z"
  }));
});
Optometry.displayName = 'Optometry';
Optometry.defaultProps = {
  'aria-label': 'Optometry'
};
export default Optometry;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Optometry.js
// module id = 3054
// module chunks = 11